import { FC } from 'react';
import { Box, Paper, Typography, useTheme } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { Trans } from '@libs/i18n';
import { InfoIcon } from '@phosphor-icons/react';

export const AssessmentTipsCard: FC = observer(() => {
  const theme = useTheme();

  return (
    <Paper
      elevation={1}
      variant="outlined"
      sx={{
        width: '100%',
        borderRadius: 2,
        mt: 2,
      }}
    >
      <Box sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
          <InfoIcon color={theme.palette.black[300]} size={20} />
          <Typography variant="textMD_medium">
            <Trans i18nKey="assessments.new.tips.title" />
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 3 }}>
          <Typography variant="textSM_medium">
            <Trans i18nKey="assessments.new.tips.BeforeAssessment.title" />
          </Typography>
          <Box component="ul" sx={{ mt: 1, paddingInlineStart: 3 }}>
            <Typography component="li" variant="textSM_regular" sx={{ color: 'text.tertiary' }}>
              <Trans i18nKey="assessments.new.tips.BeforeAssessment.description1" />
            </Typography>
            <Typography component="li" variant="textSM_regular" sx={{ color: 'text.tertiary' }}>
              <Trans i18nKey="assessments.new.tips.BeforeAssessment.description2" />
            </Typography>
            <Typography component="li" variant="textSM_regular" sx={{ color: 'text.tertiary' }}>
              <Trans i18nKey="assessments.new.tips.BeforeAssessment.description3" />
            </Typography>
          </Box>
          <Box sx={{ width: '100%', height: '1px', backgroundColor: 'grey.100', mt: 1.5 }} />
          <Typography variant="textSM_medium">
            <Trans i18nKey="assessments.new.tips.DuringAssessment.title" />
          </Typography>
          <Box component="ul" sx={{ mt: 1, paddingInlineStart: 3 }}>
            <Typography component="li" variant="textSM_regular" sx={{ color: 'text.tertiary' }}>
              <Trans i18nKey="assessments.new.tips.DuringAssessment.description1" />
            </Typography>
            <Typography component="li" variant="textSM_regular" sx={{ color: 'text.tertiary' }}>
              <Trans i18nKey="assessments.new.tips.DuringAssessment.description2" />
            </Typography>
            <Typography component="li" variant="textSM_regular" sx={{ color: 'text.tertiary' }}>
              <Trans i18nKey="assessments.new.tips.DuringAssessment.description3" />
            </Typography>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
});
